// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vurBzR1PFEsZsrURj5r1{color:var(--gray-60);justify-content:center;padding:12px 0;font-size:12px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noResults": `vurBzR1PFEsZsrURj5r1`
};
export default ___CSS_LOADER_EXPORT___;
